"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
var State_1 = require("./State");
/**
 * @hidden
 * State machine context, between states.
 */
var Context = /** @class */ (function () {
    function Context(state) {
        this.emit = [];
        this.enterState = false;
        this.hasData = false;
        this.hasState = false;
        this.nextEvents = [];
        this.replies = [];
        this.usingDefaultHandler = false;
        if (state) {
            this._state = state;
        }
    }
    Object.defineProperty(Context.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
            this.hasData = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "isComplexState", {
        get: function () {
            return State_1.isComplexState(this.state);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "state", {
        get: function () {
            return this._state;
        },
        set: function (value) {
            this._state = value;
            this.hasState = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "stateName", {
        get: function () {
            return State_1.stateName(this.state);
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.stateEq = function (other) {
        return other ? State_1.stateEquals(this.state, other.state) : false;
    };
    return Context;
}());
exports.Context = Context;
//# sourceMappingURL=Context.js.map